module.exports = __webpack_public_path__ + "static/media/carousel-img01.ea1f9930.png";